import React from 'react';
import styles from './segmented.module.css';

interface SegmentedProps {
  value: string;
  options: {
    key: string;
    value: string;
  }[];
  onChange?: (value: string) => void;
  style?: TypeAny;
  buttonStyle?: TypeAny;
  theme?: 'light' | 'gray';
}

function Segmented({
  value,
  options,
  onChange,
  theme = 'light',
  style,
  buttonStyle
}: SegmentedProps) {
  const handleSelect = (option: string) => {
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <div className={`${styles.segmentedContainer} ${styles[theme]}`} style={style}>
      {options.map((option) => (
        <div
          key={option.key}
          onClick={() => handleSelect(option.key)}
          className={`${styles.segmentedItem} ${value === option.key ? styles.active : ''} ${buttonStyle || ''}`}
          // style={buttonStyle}
        >
          {option.value}
        </div>
      ))}
    </div>
  );
}

export default Segmented;
